import React from 'react'
import ReCAPTCHA from 'react-google-recaptcha'

import { URL_CONST } from 'utils/urlConsts'
import {
  email as emailValidation,
  required as requiredValidation,
  validateAll,
} from 'utils/validations'

import {
  LOGIN_STEPS,
  MAP_SSO_NAME_BY_VIEW,
  MSP_SSO_LOGO_BY_VIEW,
  SSO_VIEWS,
} from 'containers/Login/constants'

import Icon from 'components/lib/IconFA'
import InfoPopup from 'components/lib/InfoPopup'

import Input from './Input'
import Prizes from './Prizes'

const InfoPopupComponent = () => (
  <div>
    Password must meet the following requirements:
    <ul>
      <li>Not based on user account name.</li>
      <li>Not been used before.</li>
      <li>
        Contains at least 6 characters including uppercase and lowercase letters, numbers and
        special signs.
      </li>
    </ul>
  </div>
)

export default class LoginForm extends React.Component {
  state = {
    email: '',
    password: '',
    newPassword: '',
    repeatNewPassword: '',
    reCaptcha: '',

    validations: {
      email: '',
      password: '',
      newPassword: '',
      repeatNewPassword: '',
      reCaptcha: '',
    },

    SSOView: null,
  }

  reCaptchaRef = React.createRef()

  v = {
    email: {
      name: 'email',
      validator: (value) => validateAll([requiredValidation(value), emailValidation(value)]),
    },
    password: {
      name: 'password',
      validator: (value) => requiredValidation(value),
    },
    newPassword: {
      name: 'newPassword',
      validator: (value) => requiredValidation(value),
    },
    repeatNewPassword: {
      name: 'repeatNewPassword',
      validator: (value) => requiredValidation(value),
    },
    reCaptcha: {
      name: 'reCaptcha',
      validator: (value) => requiredValidation(value),
    },
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.ssoUrl) {
      window.location = nextProps.ssoUrl
    }

    if (!nextProps.loginSubmitLoader && this.props.loginSubmitLoader && this.reCaptchaRef.current) {
      this.reCaptchaRef.current.reset()
    }

    return null
  }

  isFormValid = () => {
    const { SSOView } = this.state
    const { loginStep } = this.props

    let validators
    const currentValidation = {}

    if (SSOView) {
      validators = [this.v.email]
    } else if (loginStep === LOGIN_STEPS.PASSWORD_EXPIRED_STEP) {
      validators = [this.v.password, this.v.newPassword, this.v.repeatNewPassword]
    } else if (
      loginStep === LOGIN_STEPS.PASSWORD ||
      loginStep === LOGIN_STEPS.PASSWORD_CAPTCHA ||
      loginStep === LOGIN_STEPS.SSO_ENFORCEMENT
    ) {
      validators = [this.v.email, this.v.password]
      if (loginStep === LOGIN_STEPS.PASSWORD_CAPTCHA) validators.push(this.v.reCaptcha)
    }

    validators.forEach((e) => {
      const error = e.validator(this.state[e.name])
      currentValidation[e.name] = error
    })

    this.setState({ validations: currentValidation })

    return !Object.keys(currentValidation).filter((e) => currentValidation[e]).length
  }

  submitForm = () => {
    const { SSOView, email, password, reCaptcha, newPassword, repeatNewPassword } = this.state
    const {
      loginStep,

      submitLogin,
      submitExpiredPass,
      submitSSO,
    } = this.props

    if (!this.isFormValid()) return

    let func
    const body = { username: email }

    if (SSOView) {
      func = submitSSO
      body.idp = MAP_SSO_NAME_BY_VIEW[SSOView]
    } else if (loginStep === LOGIN_STEPS.PASSWORD_EXPIRED_STEP) {
      func = submitExpiredPass
      body.password = password
      body.newPassword = newPassword
      body.repeatNewPassword = repeatNewPassword
    } else if (
      loginStep === LOGIN_STEPS.PASSWORD ||
      loginStep === LOGIN_STEPS.PASSWORD_CAPTCHA ||
      loginStep === LOGIN_STEPS.SSO_ENFORCEMENT
    ) {
      func = submitLogin
      body.password = password
      if (loginStep === LOGIN_STEPS.PASSWORD_CAPTCHA) body.recaptchaResponse = reCaptcha
    } else throw new Error('submitForm: view is not supported')

    func(body)
  }

  handleKeydown = (e) => {
    if (e.keyCode === 13) this.submitForm()
  }

  setSSOView = (SSOView) => {
    const { resetError } = this.props
    resetError()
    this.setState({ SSOView })
  }

  render() {
    const {
      email,
      password,
      validations,

      SSOView,
    } = this.state
    const {
      loginStep,

      SubmitButton,
    } = this.props

    const EmailInput = (
      <Input.Field
        id="SignIn_Email_input"
        value={email}
        name="email"
        type="email"
        placeholder="Email"
        onChange={(e) => this.setState({ email: e.target.value })}
        meta={{
          error: validations.email,
          touched: true,
        }}
      />
    )

    const PasswordInput = (
      <Input.Field
        id="SignIn_Password_input"
        value={password}
        name="password"
        type="password"
        placeholder="Password"
        onChange={(e) => this.setState({ password: e.target.value })}
        meta={{
          error: validations.password,
          touched: true,
        }}
      />
    )

    const LoginButton = <SubmitButton text="Login" onClick={this.submitForm} />

    let RelevantView

    if (SSOView) {
      RelevantView = (
        <div>
          <img
            style={{ marginBottom: '25px', maxWidth: '230px' }}
            src={MSP_SSO_LOGO_BY_VIEW[SSOView]}
          />

          {EmailInput}
          {LoginButton}

          <div className="inline-button" onClick={() => this.setSSOView(null)}>
            <Icon name="angle-left" marginRight="5px" />
            Back to Login
          </div>
        </div>
      )
    } else if (loginStep === LOGIN_STEPS.PASSWORD_EXPIRED_STEP) {
      RelevantView = (
        <div>
          <div style={{ marginBottom: '15px' }}>Password Expired</div>
          <div>
            <b>{email}</b>
          </div>
          {PasswordInput}
          <div className="newPasswordLabel">
            <div style={{ marginRight: '0.2em', fontWeight: 'bold' }}>
              Enter your new password below
            </div>
            <InfoPopup
              iconClassName="info-icon"
              popupPosition="right center"
              ContentComponent={InfoPopupComponent}
            />
          </div>
          <Input.Field
            id="SignIn_NewPassword_input"
            name="newPassword"
            type="password"
            placeholder="New Password"
            onChange={(e) => this.setState({ newPassword: e.target.value })}
            meta={{
              error: validations.newPassword,
              touched: true,
            }}
          />
          <Input.Field
            id="SignIn_RepeatNewPassword_input"
            name="repeatNewPassword"
            type="password"
            placeholder="Confirm"
            onChange={(e) => this.setState({ repeatNewPassword: e.target.value })}
            meta={{
              error: validations.repeatNewPassword,
              touched: true,
            }}
          />
          {LoginButton}
        </div>
      )
    } else if (
      loginStep === LOGIN_STEPS.PASSWORD ||
      loginStep === LOGIN_STEPS.PASSWORD_CAPTCHA ||
      loginStep === LOGIN_STEPS.SSO_ENFORCEMENT
    ) {
      RelevantView = (
        <div>
          {EmailInput}
          {PasswordInput}

          {loginStep === LOGIN_STEPS.PASSWORD_CAPTCHA && (
            <ReCAPTCHA
              size="compact"
              ref={this.reCaptchaRef}
              sitekey="6Lf70w4UAAAAAG1nRIy_SNed9cd3WcKVOA3wdP4n"
              onChange={(e) => this.setState({ reCaptcha: e })}
            />
          )}

          <a className="fr" href={URL_CONST.login.resetPassword}>
            Forgot Password?
          </a>

          {LoginButton}

          <div className="separator-container">
            <span>OR</span>
          </div>

          <div
            className="alternative-auth"
            onClick={() => (window.location = '/auth/login/google-oauth2/')}
          >
            <img src="/static/webapp/images/button-icons/google.svg" />
            Login with Google
          </div>

          <div className="alternative-auth" onClick={() => this.setSSOView(SSO_VIEWS.OKTA)}>
            <img src="/static/webapp/images/button-icons/sso-okta.svg" />
            Login with Okta
          </div>

          <div className="alternative-auth" onClick={() => this.setSSOView(SSO_VIEWS.AZUREAD)}>
            <img src="/static/webapp/images/button-icons/sso-azuread.svg" />
            Login with Azure AD
          </div>

          <div className="alternative-auth" onClick={() => this.setSSOView(SSO_VIEWS.PING)}>
            <img src="/static/webapp/images/button-icons/ping-federate.svg" />
            Login with Ping Identity
          </div>

          <Prizes />
        </div>
      )
    } else throw new Error('submitForm: view is not supported')

    return <div onKeyDown={this.handleKeydown}>{RelevantView}</div>
  }
}
